import React, { useState, useEffect } from "react"
import { Switch, Route, useLocation } from "react-router-dom"
import Login from "./components/auth/login"
import Logout from "./components/auth/logout"
import Home from "./components/Home/index"
import NotFound from "./components/not-found"
import Snackbar from "@material-ui/core/Snackbar"
import MuiAlert from "@material-ui/lab/Alert"
import IconButton from "@material-ui/core/IconButton"
import CloseIcon from "@material-ui/icons/Close"

import { ProtectedRoute } from "./middlewares/routes-auth.middleware"

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const App = () => {
    const [rateLimitError, setRateLimitError] = useState({ open: false, message: "" });
    const location = useLocation();

    // Reset rate limit UI when navigating to login or logout
    useEffect(() => {
        if (location.pathname === "/login" || location.pathname === "/logout" || location.pathname === "/") {
            document.body.classList.remove('global-rate-limit-active');
            setRateLimitError({ open: false, message: "" });
        }
    }, [location]);

    useEffect(() => {
        const handleRateLimitExceeded = (event) => {
            const { message } = event.detail;
            setRateLimitError({ open: true, message: message });

            // 1. Add global CSS flag to clear obstructive UI elements (Backdrops, Loaders)
            document.body.classList.add('global-rate-limit-active');

            // 2. Perform manual cleanup for elements that don't react to CSS classes (like locked body scroll)
            setTimeout(() => {
                // Dismiss any active Material-UI dialogs by clicking cancel
                document.querySelectorAll('button').forEach(btn => {
                    if (btn.textContent.toLowerCase().includes('cancel')) btn.click();
                });

                // Ensure scroll is restored if a modal was open
                document.body.style.overflow = 'auto';
                document.documentElement.style.overflow = 'auto';
            }, 100);

            // 3. Reset the global flag after 10s to restore normal UI behavior
            setTimeout(() => {
                document.body.classList.remove('global-rate-limit-active');
            }, 10000);
        };

        window.addEventListener('api-rate-limit-exceeded', handleRateLimitExceeded);
        return () => window.removeEventListener('api-rate-limit-exceeded', handleRateLimitExceeded);
    }, []);

    const handleCloseError = (event, reason) => {
        if (reason === 'clickaway') return;
        setRateLimitError({ ...rateLimitError, open: false });
    };

    return (
        <>
            <style>
                {`
                    /* Global cleanup when rate limit is active */
                    .global-rate-limit-active .MuiBackdrop-root,
                    .global-rate-limit-active .backdrop {
                        display: none !important;
                        visibility: hidden !important;
                        opacity: 0 !important;
                        pointer-events: none !important;
                    }

                    /* Specificity boost for the global alert */
                    .rate-limit-notification {
                        display: flex !important;
                        visibility: visible !important;
                        opacity: 1 !important;
                        z-index: 9999 !important;
                    }
                `}
            </style>

            <Switch>
                <ProtectedRoute path="/offer" component={Home} />
                <ProtectedRoute path="/request" component={Home} />
                <ProtectedRoute path="/home" component={Home} />
                <Route path="/logout" exact component={Logout} />
                <Route path="/login" exact component={Login} />
                <Route path="/" exact component={Login} />
                <Route path="*" component={NotFound} />
            </Switch>

            {/* Global Rate Limit Alert */}
            <Snackbar 
                open={rateLimitError.open} 
                autoHideDuration={5000} 
                onClose={handleCloseError}
                className="rate-limit-notification"
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                action={
                    <IconButton size="small" aria-label="close" color="inherit" onClick={handleCloseError}>
                        <CloseIcon fontSize="small" />
                    </IconButton>
                }
            >
                <Alert severity="error" onClose={handleCloseError}>
                    {rateLimitError.message}
                </Alert>
            </Snackbar>
        </>
    );}

export default App
